import NetMsgDataToBuffer from "../../../framework/net/net_msgdata_to_buffer";
import { SlotGame } from "./proto/proto_slot_game";
import { SlotRoom } from "./proto/proto_slot_room";

export class NetMsgSlot extends NetMsgDataToBuffer {
    //发送命令名|发送结构体|收包命令|收包结构体|协议类型:1为登录服，2为麻将游戏服，3为Skynet扑克服
    //登陆或重连发送的数据

    static SpinReq:any[] = ['Game.SpinReq',SlotGame.SpinReq,'Game.SpinRsp',SlotGame.SpinRsp, 3]


    static RoomInfo: any[] = [null, null, "Room.RoomInfo", SlotRoom.RoomInfo, 3]    

    static LeaveRoomNotify: any[] = [null, null, "Room.LeaveBroadcast", SlotRoom.LeaveBroadcast, 3]

    static LeaveRoomReq: any[] = ["Room.LeaveReq", SlotRoom.LeaveReq, "Room.LeaveRsp", SlotRoom.LeaveRsp, 3]

    static CoinBalanceReq: any[] = ["Room.UserCoinBalanceReq", SlotRoom.UserCoinBalanceReq,null, null, 3]
    static CoinBalanceNotify: any[] = [null, null, "Room.UserCoinBalanceNotify", SlotRoom.UserCoinBalanceNotify, 3]

    static ChatNotify: any[] = [null, null, "Room.ChatMsgBroadcast", SlotRoom.ChatMsgBroadcast, 3]

    static ChatReq: any[] = ["Room.ChatMsgReq", SlotRoom.ChatMsgReq, "Room.ChatMsgRsp", SlotRoom.ChatMsgRsp, 3]

    static CarryMoneyReq: any[] = ["Room.CarryMoneyReq", SlotRoom.CarryMoneyReq, "Room.CarryMoneyRsp", SlotRoom.CarryMoneyRsp, 3]
    
}